<template>
    <b-container :class="`mt-5 pt-5 ${containerClassName || ''}`">
        <b-row :class="`justify-content-center ${className || 'bg-white'}`">
            <b-col cols="12">
                <div class="d-flex">
                    <div id="tour-pickup" class="card--sender mr-1" :class="{ 'active': delivery_pickup === 'pickup' }"
                        @click="delivery_pickup = 'pickup'">
                        <div class="circle">
                            <feather-icon class="shopping-cart" icon="ShoppingCartIcon" />
                        </div>
                        <h6>Ambil Sendiri</h6>
                    </div>
                    <div id="tour-delivery" class="card--sender" :class="{ 'active': delivery_pickup === 'delivery' }"
                        @click="delivery_pickup = 'delivery'">
                        <div class="circle">
                            <feather-icon class="truck" icon="TruckIcon" />
                        </div>
                        <h6>Dikirim</h6>
                    </div>
                </div>
                <hr style="border: 1px solid #E4E5EC;">

                <b-form @submit.prevent="submit">
                    <b-row>
                        <b-col cols="12" class="mb-2">
                            <b-form-group class="custom__form--input mb-0">
                                <label for="date-creation">Tanggal Transaksi <span class="text-danger">*</span></label>
                                <b-form-input id="date-creation" v-model="formPayload.date" class="custom__input pt-1"
                                    type="date" :max="todayDate" placeholder="DD/MM/YYYY" required />
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" class="mb-2" v-if="delivery_pickup === 'delivery'">
                            <b-form-group class="custom__form--input mb-0">
                                <label for="date-creation">Tanggal Pengiriman <span class="text-danger">*</span></label>
                                <b-form-input id="date-creation" v-model="formPayload.delivery_date"
                                    class="custom__input pt-1" type="date" placeholder="DD/MM/YYYY" required />
                            </b-form-group>
                        </b-col>

                        <!-- Sales -->
                        <b-col cols="12" class="mb-2">
                            <b-form-group class="custom__form--input mb-0">
                                <label for="v-sales">Sales</label>
                                <v-select v-model="formPayload.seller_uuid" label="title"
                                    :reduce="option => option.label" :options="options" placeholder="Pilih Sales"
                                    class="text-dark fw-bold-700" @search="onSearch" />
                            </b-form-group>
                        </b-col>
                        <!-- Faktur, Non Faktur -->
                        <b-col cols="12" class="mb-2">
                            <label class="text-dark fw-bold-600" style="font-size: 14px !important;">Pilih Faktur atau
                                Non-faktur <span class="text-danger">*</span></label><br>
                            <small class="size12 text-dark text-darken-4 fw-bold-600">Pilih faktur jika transaksi ini
                                memerlukan faktur pajak</small>
                            <b-form-group class="custom__form--input mb-0 mt-1">
                                <b-form-radio v-model="invoice_status" name="some-radios" value="1" class="mb-1">
                                    Faktur Pajak
                                </b-form-radio>
                                <b-form-radio v-model="invoice_status" name="some-radios" value="0">
                                    Non-faktur Pajak
                                </b-form-radio>
                            </b-form-group>
                        </b-col>
                        <!-- nomor po -->
                        <b-col v-if="customerType !== 'Non Ritel'" cols="12" class="mb-2">
                            <b-form-group class="custom__form--input mb-0" label="Nomor PO / SO" label-for="v-nomor-po">
                                <b-form-input id="v-nomor-po" v-model="formPayload.po_so_number" class="custom__input"
                                    type="text" placeholder="x-xxxx-xxxx" />
                            </b-form-group>
                        </b-col>
                        
                        <!-- Catatan Transaksi — Redesigned -->
                        <b-col cols="12" class="mb-2 custom__form--input">
                            <label class="text-dark fw-bold-600" style="font-size: 14px !important">Catatan Transaksi</label>

                            <!-- Chip row: scrollable, always visible -->
                            <div class="note-chips-wrapper">
                                <div class="note-chips">
                                    <!-- Default chip -->
                                    <div
                                        class="note-chip"
                                        :class="{ active: selectedChipId === '__default__', 'editing': editingNoteId === '__default__' }"
                                        @click="selectChip(defaultOrderNote)"
                                    >
                                        <span>📄 Default</span>
                                    </div>

                                    <!-- Saved note chips -->
                                    <div
                                        v-for="note in orderNotes"
                                        :key="note.id"
                                        class="note-chip"
                                        :class="{ active: selectedChipId === note.id, editing: editingNoteId === note.id }"
                                    >
                                        <span class="chip-label" @click="selectChip(note)">{{ note.name }}</span>
                                        <span class="chip-actions">
                                            <feather-icon icon="Edit2Icon" size="12" @click.stop="startEditChip(note)" />
                                            <feather-icon icon="Trash2Icon" size="12" @click.stop="deleteOrderNote(note.id)" />
                                        </span>
                                    </div>

                                    <!-- + Baru chip -->
                                    <div
                                        id="note-chip-baru"
                                        class="note-chip note-chip--new"
                                        :class="{ active: selectedChipId === '__new__' }"
                                        @click="startNewNote"
                                    >
                                        <feather-icon icon="PlusIcon" size="12" />
                                        <span>Baru</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Edit mode banner -->
                            <transition name="slide-down">
                                <div v-if="editingNoteId && editingNoteId !== '__default__'" class="note-edit-banner">
                                    <div class="d-flex align-items-center">
                                        <feather-icon icon="Edit2Icon" size="13" class="mr-1" />
                                        <span>Sedang mengedit: <strong>{{ editNoteForm.name }}</strong></span>
                                    </div>
                                    <div class="d-flex" style="gap: 6px">
                                        <b-button size="sm" variant="outline-secondary" @click="cancelEditOrderNote">Batal</b-button>
                                        <b-button size="sm" variant="success" @click="updateOrderNote">
                                            <feather-icon icon="CheckIcon" size="12" class="mr-25" />Simpan
                                        </b-button>
                                    </div>
                                </div>
                            </transition>

                            <!-- Main textarea -->
                            <b-form-textarea
                                v-model="formPayload.invoice_notes"
                                rows="3"
                                placeholder="Tulis catatan..."
                                class="custom__textarea"
                                :class="{ 'note-compose-active': isComposing, 'note-edit-active': !!editingNoteId }"
                                maxlength="255"
                                @focus="onTextareaFocus"
                                @keydown="handleTextareaRows"
                            />

                            <!-- Inline save name form -->
                            <transition name="slide-down">
                                <div v-if="showSaveInline" class="note-save-inline mt-1">
                                    <p class="note-save-inline__label">Masukkan nama untuk catatan ini:</p>
                                    <b-form-input
                                        v-model="saveNoteForm.name"
                                        placeholder="Nama catatan..."
                                        size="sm"
                                        maxlength="255"
                                        autofocus
                                        @keyup.enter="saveCurrentNote"
                                    />
                                    <div class="d-flex justify-content-end mt-1" style="gap: 6px">
                                        <b-button size="sm" variant="outline-secondary" @click="cancelSaveInline">Batal</b-button>
                                        <b-button size="sm" variant="primary" @click="saveCurrentNote">
                                            <feather-icon icon="SaveIcon" size="12" class="mr-25" />Simpan
                                        </b-button>
                                    </div>
                                </div>
                            </transition>

                            <!-- Action row -->
                            <div class="d-flex justify-content-between align-items-center mt-1">
                                <b-button
                                    v-if="(isComposing || !editingNoteId) && !showSaveInline && !editingNoteId"
                                    size="sm"
                                    variant="outline-primary"
                                    @click="openSaveInline"
                                >
                                    <feather-icon icon="SaveIcon" size="14" class="mr-25" />
                                    Simpan Catatan
                                </b-button>
                                <span v-else />
                                <small class="note-char-count text-muted">
                                    {{ (formPayload.invoice_notes || '').length }}/255
                                </small>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="delivery_pickup === 'delivery'">
                        <!-- nama penerima -->
                        <b-col cols="12" class="mb-2">
                            <label label-for="penerima" class="text-dark fw-bold-600"
                                style="font-size: 14px !important;">Nama Penerima<span
                                    class="text-danger">*</span></label>
                            <b-form-group class="custom__form--input mb-0">
                                <b-form-input id="penerima" v-model="formPayload.receiver_name" class="custom__input"
                                    placeholder="Nama Anda" />
                            </b-form-group>
                        </b-col>

                        <!-- Nomor Handphone Penerima -->
                        <b-col cols="12" class="mb-2">
                            <label label-for="hp" class="text-dark fw-bold-600"
                                style="font-size: 14px !important;">Nomor Handphone Penerima<span
                                    class="text-danger">*</span></label>
                            <b-row>
                                <b-col cols="4" class="pr-0">
                                    <v-select v-model="formPayload.selectedCountry" :label="currentLabel"
                                        :options="countryListData" :clearable="false"
                                        @keyup.stop.native="searchCountry">
                                        <template #selected-option="{ country_flag, dial_code_preview }">
                                            <div :key="`selected-option-${dial_code_preview}`" class="d-flex align-items-center" style="gap: 6px">
                                                <img :src="country_flag" :alt="dial_code_preview"
                                                    style="width: 24px; height: 24px" />
                                                <p class="size12 mb-0">({{ dial_code_preview }})</p>
                                            </div>
                                        </template>
                                        <template #option="{ country_flag, dial_code_preview }">
                                            <div :key="`option-${dial_code_preview}`" class="d-flex align-items-center" style="gap: 8px">
                                                <img :src="country_flag" :alt="dial_code_preview"
                                                    style="width: 24px; height: 24px" />
                                                <p class="mb-0">{{ dial_code_preview }}</p>
                                            </div>
                                        </template>
                                    </v-select>
                                </b-col>
                                <b-col cols="8">
                                    <b-form-group class="custom__form--input">
                                        <b-form-input id="v-phone" type="tel" placeholder="Nomor Telpon Penerima" v-model="formPayload.receiver_phone_number" class="custom__input" @change="handlePhoneNumber" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>

                        <!-- Alamat Penerima -->
                        <b-col cols="12" class="mb-2 custom__form--input">
                            <label label-for="address" class="text-dark fw-bold-600"
                                style="font-size: 14px !important;">Alamat Penerima<span
                                    class="text-danger">*</span></label>
                            <b-form-group class="custom__form--input mb-0">
                                <b-form-textarea id="address" v-model="formPayload.receiver_address" rows="3"
                                    placeholder="Alamat" class="custom__textarea" maxlength="100" />
                            </b-form-group>
                            <small class="size12 text-dark text-darken-4 font-italic">
                                *Maksimal 100 Karakter
                            </small>
                        </b-col>

                        <b-col cols="12">
                            <div class="d-flex align-items-center" v-for="(item, index) in additional_costs"
                                :key="index">
                                <b-form-group class="custom__form--input mr-1">
                                    <label for="value-diskon">Nama Biaya</label>
                                    <input :id="`nama-biaya-${index}`" type="text"
                                        v-model="additional_costs[index].additional_fee_note"
                                        class="custom__input pl-2 w-100" placeholder="Masukan Nama Biaya">
                                </b-form-group>
                                <b-form-group class="custom__form--input">
                                    <label for="value-diskon">Nominal Biaya</label>
                                    <input :id="`nominal-biaya-${index}`" type="text"
                                        :value="additional_costs[index].additional_fee_amount"
                                        class="custom__input pl-2 w-100" placeholder="Masukan Nominal Biaya"
                                        @input="getRupiah(index)" @change="getRupiah(index)">
                                </b-form-group>
                                <b-button id="button--hapus__biaya" class="p-1 ml-25" variant="outline-danger"
                                    @click="removeItem(index)">
                                    <feather-icon icon="Trash2Icon" />
                                </b-button>
                            </div>
                        </b-col>
                        <b-button id="button--tambah__biaya" class="w-100" variant="outline-dark" @click="repeateAgain"
                            v-if="additional_costs && additional_costs.length < 3">
                            + Tambah Biaya Tambahan
                        </b-button>
                    </b-row>
                    <b-row v-if="!hideButtonSubmit">
                        <!-- Button -->
                        <b-col cols="12" class="mb-2">
                            <b-button type="submit" :disabled="isLoading" class="btn-block size16 py-2 border-8">
                                <b-spinner v-if="isLoading" class="mr-1" variant="primary" />
                                Proses
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </b-col>
        </b-row>
        <!-- <app-tour :nameTour="'cashierTour7'" :steps="steps" /> -->

        <!-- Modals removed: notes now managed inline -->
    </b-container>
</template>

<script>
import _ from 'lodash'
import vSelect from 'vue-select'
import {
    BContainer, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BFormRadio, BSpinner, BFormTextarea, BFormSelect, BFormSelectOption, BFormCheckbox
} from 'bootstrap-vue'
import moment from 'moment'
import AppTour from '@core/components/app-tour/AppTour.vue'
import { checkPermission, successNotification, errorNotification, preformatFloat } from '@/auth/utils'
import QuilEditor from '@/components/QuilEditor.vue'
import { country_codes } from '@/libs/country-codes'

export default {
    components: {
        BContainer,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BForm,
        BFormRadio,
        BButton,
        BSpinner,
        BFormTextarea,
        AppTour,
        QuilEditor,
        vSelect,
        BFormSelect, BFormSelectOption, BFormCheckbox
    },
    props: {
        // eslint-disable-next-line vue/require-default-prop
        submit: {
            type: Function,
        },
        className: {
            type: String,
        },
        containerClassName: {
            type: String,
        },
        hideButtonSubmit: {
            type: Boolean,
        }
    },
    setup() {
        return {
            checkPermission,
            successNotification,
            errorNotification,
            preformatFloat,
        }
    },
    data() {
        const newDate = new Date()
        const endDate = moment(newDate).format('YYYY-MM-DD')
        const customerData = JSON.parse(localStorage.getItem('customer_data'))

        return {
            customerData,
            countryCodes: country_codes,
            selectedCountryCode: '+62',
            invoice_status: '',
            todayDate: endDate,
            selectedFaktur: '',
            delivery_pickup: 'pickup',
            formPayload: {
                delivery_pickup: "pickup",
                payment_method: "",
                customer_uuid: "",
                invoice_status: 0,
                po_so_number: "",
                receiver_name: customerData?.name || "",
                receiver_phone_number: customerData?.phone_number || "",
                receiver_phone_number_country: customerData?.phone_number_country || "",
                receiver_address: customerData?.address || "",
                selectedCountry: {
                    country_code: customerData?.phone_number_country?.country_code || "ID",
                    country_flag: customerData?.phone_number_country?.country_flag || "https://flagsapi.com/ID/shiny/64.png",
                    country_name: customerData?.phone_number_country?.country_name || "Indonesia",
                    dial_code_preview: customerData?.phone_number_country?.dial_code_preview || "+62",
                    dial_code_value: customerData?.phone_number_country?.dial_code_value || "62",
                },
                date: endDate,
                delivery_date: endDate,
                display_vat: 0,
                invoice_notes: "",
            },
            orderNotes: [],
            selectedOrderNote: null,
            saveNoteChecked: false,
            newNoteName: "",
            // Notes UI state
            selectedChipId: '__default__',
            isComposing: false,
            showSaveInline: false,
            receiver_phone_number: '',
            additional_costs: [],
            customerType: localStorage.getItem('customer_type'),
            customerUuid: localStorage.getItem('customer_uuid'),
            isLoading: false,
            userData: JSON.parse(localStorage.getItem('userData')),
            formPayloadDelivery: {
                receiver_name: customerData?.name,
                receiver_phone_number: customerData?.phone_number || '62',
                receiver_address: customerData?.address,
            },
            isFullPayment: false,
            amount_down_payment: 0,
            options: [],
            characterCount: 0,
            countryListData: [],
            searchQueryData: "",
            editingNoteId: null,
            editNoteForm: {
                name: '',
                note: '',
            },
            saveNoteForm: {
                name: ''
            },
        }
    },
    computed: {
        defaultOrderNote() { 
            return { 
                    id: '__default__',
            name: '📄 Default',
            note: this.userData?.branch?.order_invoice_notes || ''
            }
        },
        orderNoteOptions() {
            return [
                this.defaultOrderNote,
                {
                    id: '__new__',
                    name: '➕ Tambah Catatan Baru'
                },
                ...this.orderNotes
            ]
        },
        currentLabel() {
            return /^\d+$/.test(this.searchQueryData)
                ? "dial_code_value"
                : "country_name";
        },
        dialCode() {
            const selectedCountry = this.countryListData.find(
                (country) =>
                    country.country_code ===
                    this.formPayload.selectedCountry?.country_code
            );
            return selectedCountry ? selectedCountry.dial_code_value : "62";
        },
    },
    watch: {
        amount_down_payment(value, oldValue) {
            const amount = parseFloat(preformatFloat(value))
            this.$emit('amount_dp', value || '')
            if (amount > parseFloat(this.$route.query.total)) {
                this.$swal({
                    title: 'Warning!',
                    text: 'Jumlah dp tidak boleh lebih dari total belanja',
                    icon: 'warning',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                })
                return false
            }
            // this.$router.push({ name: 'payment.index', query: { bonus: this.$route.query.bonus, total: this.$route.query.total, type_payment: this.isFullPayment ? 1 : 0, amount_dp: value } })
        },
        '$store.state.checkout.isLoading': function (value) {
            this.isLoading = value
        },
        'formPayload.invoice_notes': function (newValue) {
            if (newValue) {
                const lines = newValue.split('\n');
                // If pasted text or modifications exceed 5 rows, automatically chop off anything after line 5
                if (lines.length > 5) {
                    this.formPayload.invoice_notes = lines.slice(0, 5).join('\n');
                }
            }
        },
        selectedFaktur(value) {
            this.formPayload.invoice_status = value
        },
        additional_costs: {
            handler(addtional_costs) {
                let cashTotalPayment = parseFloat(this.$route.query.total) || 0
                let total = 0
                this.formPayload.additional_fees = addtional_costs
                this.$store.commit('cart/SET_FORM_ADDITIONAL_COST', this.additionalCost)
                for (let index = 0; index < addtional_costs.length; index++) {
                    const element = addtional_costs[index];
                    total += parseFloat(preformatFloat(element.additional_fee_amount)) || 0
                }
                cashTotalPayment += total
                this.$store.commit('cart/SET_TOTAL_TRANSAKSI', cashTotalPayment)
                this.$store.commit('cart/SET_TOTAL_ADDITIONAL_COST', total)
                localStorage.setItem('cash_total_payment', cashTotalPayment)
                localStorage.setItem('additional_cost', JSON.stringify(addtional_costs))
            },
            deep: true,
        },
        formPayload: {
            handler(value) {
                this.invoice_status = value.invoice_status
                localStorage.setItem('delivery_pickup', value.delivery_pickup)
                localStorage.setItem('poSO', JSON.stringify(value))
                this.$emit('payload', value)
                this.$emit('getPhoneCode', this.selectedCountryCode)
            },
            deep: true,
        },
        invoice_status: {
            handler(value) {
                localStorage.setItem('invoice_status', value)
                this.formPayload.invoice_status = value
                this.formPayload = {
                    ...this.formPayload,
                    invoice_status: value,
                }
                localStorage.setItem('payloadDelivery', JSON.stringify(this.formPayload))
            },
            deep: true,
        },
        formPayloadDelivery: {
            handler(value) {
                this.formPayload = {
                    ...this.formPayload,
                    ...value,
                }
                localStorage.setItem('payloadDelivery', JSON.stringify(value))
            },
            deep: true,
        },
        '$store.state.cashier.userData': {
            handler(value) {
                this.userData = value
            },
            deep: true,
        },
        '$store.state.customer.customer': {
            handler(value) {
                this.formPayload.receiver_name = value.name
                this.formPayload.receiver_phone_number = value.phone_number
                this.formPayload.receiver_address = value.address
            },
            deep: true,
        },
        delivery_pickup(value) {
            const customerData = this.$store.state.customer.customer
            localStorage.setItem('delivery_pickup', value);
            
            const phoneNumber = customerData.phone_number || "";

            let cleanedValue = phoneNumber.trim();
            
            if (cleanedValue.startsWith("0")) {
                cleanedValue = cleanedValue.substring(1);
            }

            if (cleanedValue.startsWith("62")) {
                cleanedValue = cleanedValue.substring(2);
            }

            this.formPayload = {
                ...this.formPayload,
                delivery_pickup: value,
                receiver_name: customerData.name,
                receiver_phone_number: cleanedValue,
                receiver_address: customerData.address,
            }
            this.$emit('deliveryPickupChanged', value);
        },
    },
    created() {
        this.additional_costs = JSON.parse(localStorage.getItem('additional_cost'))
    },
    mounted() {
        this.getCountry()
        this.userData = JSON.parse(localStorage.getItem('userData'))
        this.invoice_status = JSON.parse(localStorage.getItem('invoice_status'))

        this.delivery_pickup = localStorage.getItem('delivery_pickup') || 'pickup';
        this.additional_costs = JSON.parse(localStorage.getItem('additional_cost')) || [];

        const userData = JSON.parse(localStorage.getItem("userData"));
        const branch = userData?.branch;

        const display_vat = Number(branch?.display_vat_on_order_invoice === true ? 1 : 0);

        const payloadTransaksi = JSON.parse(localStorage.getItem('payloadTransaksi'));
        const invoice_notes = payloadTransaksi?.invoice_notes !== undefined
            ? payloadTransaksi.invoice_notes
            : (branch?.order_invoice_notes || '');

        this.formPayload = {
            delivery_pickup: this.delivery_pickup,
            payment_method: localStorage.getItem('payment_method'),
            customer_uuid: localStorage.getItem('customer_uuid'),
            cash_total_payment: localStorage.getItem('price') || localStorage.getItem('cash_total_payment'),
            date: this.todayDate,
            delivery_date: this.todayDate,
            invoice_status: this.invoice_status,
            po_so_number: this.customerType === 'Non Ritel' ? undefined : this.$route.query.po_so_number,
            seller_uuid: this.$route.query.seller,
            display_vat: display_vat,
            invoice_notes: invoice_notes,
            selectedCountry: {
                country_code: "ID",
                country_flag: "https://flagsapi.com/ID/shiny/64.png",
                country_name: "Indonesia",
                dial_code_preview: "+62",
                dial_code_value: "62",
            },
        };

        if (this.delivery_pickup === 'pickup' && !this.$route.query.deliverypickup) {
            localStorage.removeItem('additional_cost');
            this.additional_costs = [];
        }

        this.getSales()
        this.fetchOrderNotes()
        this.selectedOrderNote = this.defaultOrderNote;
        this.formPayload.invoice_notes = this.defaultOrderNote.note;
    },
    methods: {
        // ─── Notes: new inline methods ────────────────────────────────────────
        selectChip(note) {
            if (!note) return;
            this.selectedChipId = note.id;
            this.formPayload.invoice_notes = note.note || '';
            this.isComposing = false;
            this.showSaveInline = false;
            this.editingNoteId = null;
        },
        startNewNote() {
            this.formPayload.invoice_notes = '';
            this.selectedChipId = '__new__';
            this.isComposing = true;
            this.showSaveInline = false;
            this.editingNoteId = null;
        },
        onTextareaFocus() {
            if (!this.editingNoteId) {
                this.isComposing = true;
            }
        },
        openSaveInline() {
            if (!this.formPayload.invoice_notes?.trim()) {
                return errorNotification(this, 'Warning', 'Isi catatan terlebih dahulu');
            }
            this.saveNoteForm.name = '';
            this.showSaveInline = true;
        },
        cancelSaveInline() {
            this.showSaveInline = false;
            this.saveNoteForm.name = '';
        },
        startEditChip(note) {
            this.editingNoteId = note.id;
            this.selectedChipId = note.id;
            this.editNoteForm = { name: note.name, note: note.note };
            this.formPayload.invoice_notes = note.note || '';
            this.isComposing = false;
            this.showSaveInline = false;
        },
        // ─── Notes: existing methods (updated) ────────────────────────────────
        async saveCurrentNote() {
            if (!this.saveNoteForm.name?.trim()) {
                return errorNotification(this, 'Warning', 'Nama catatan tidak boleh kosong');
            }
            try {
                await this.$store.dispatch('orderNote/postData', {
                    payload: {
                        name: this.saveNoteForm.name,
                        note: this.formPayload.invoice_notes,
                    }
                });

                this.fetchOrderNotes();
                this.cancelSaveInline();
                this.isComposing = false;

                successNotification(this, 'Success', 'Catatan berhasil disimpan');
            } catch (err) {
                let msg = "Gagal menyimpan catatan. Pastikan maksimal 5 catatan atau nama tidak duplikat.";
                if (err.response && err.response.data && err.response.data.data) {
                    const errData = err.response.data.data;
                    if (errData.name && errData.name[0]) {
                        msg = errData.name[0];
                    } else if (errData.message) {
                        msg = errData.message;
                    }
                }
                errorNotification(this, "Error", msg);
                return false;
            }
        },
        onSelectOrderNote(selected) {
            if (!selected) return;

            // Add new
            if (selected.id === '__new__') {
                this.openSaveNoteModal();
                return;
            }

            // Existing note
            this.formPayload.invoice_notes = selected.note;
        },
        startEditOrderNote(note) {
            this.startEditChip(note);
        },

        cancelEditOrderNote() {
            this.editingNoteId = null;
            this.editNoteForm = { name: '', note: '' };
            // Restore the previously selected chip's content
            if (this.selectedChipId === '__default__') {
                this.formPayload.invoice_notes = this.defaultOrderNote.note;
            }
        },


        updateOrderNote() {
            if (!this.editNoteForm.name?.trim()) {
                return errorNotification(this, 'Warning', 'Nama catatan tidak boleh kosong');
            }
            this.$store.dispatch('orderNote/editData', {
                id: this.editingNoteId,
                payload: {
                    name: this.editNoteForm.name,
                    note: this.formPayload.invoice_notes,
                }
            })
                .then(() => {
                    successNotification(this, 'Success', 'Catatan berhasil diubah.');
                    this.cancelEditOrderNote();
                    this.fetchOrderNotes();
                })
                .catch(() => {
                    errorNotification(this, 'Error', 'Gagal mengubah catatan.');
                });
        },

        handleTextareaRows(e) {
            // Get current total lines by splitting text by newline characters
            const lines = (this.formPayload.invoice_notes || '').split('\n');

            // If the user already has 5 lines and presses 'Enter', stop them from adding a 6th line
            if (lines.length >= 5 && e.key === 'Enter') {
                e.preventDefault();
            }
        },
        fetchOrderNotes() {
            this.$store.dispatch('orderNote/getData', { params: { per_page: 5 } }).then(result => {
                this.orderNotes = result.data.data.data || result.data.data || [];
                if (!this.selectedOrderNote) {
                    this.selectedOrderNote = this.defaultOrderNote;
                }
                // Re-select chip if it still exists after refresh
                const stillExists = this.orderNotes.find(n => n.id === this.selectedChipId);
                if (!stillExists && this.selectedChipId !== '__default__' && this.selectedChipId !== '__new__') {
                    this.selectedChipId = '__default__';
                    this.formPayload.invoice_notes = this.defaultOrderNote.note;
                }
            }).catch(err => console.log(err));
        },

        deleteOrderNote(id) {
            this.$store.dispatch('orderNote/deleteData', { id }).then(() => {
                this.fetchOrderNotes();
                successNotification(this, "Success", "Catatan berhasil dihapus.");
            }).catch(err => {
                errorNotification(this, "Error", "Gagal menghapus catatan.");
            });
        },
        editOrderNote(id) { 
            this.$store.dispatch('orderNote/editData', {
                id, payload: {
                    name: this.newNoteName,
                    note: this.formPayload.invoice_notes
                }
            }).then(() => {
                this.fetchOrderNotes();
                successNotification(this, "Success", "Catatan berhasil di edit");
            }).catch(err => {
                errorNotification(this, "Error", "Gagal edit catatan.")
            });
        },
        async saveNoteIfRequested() {
            if (this.saveNoteChecked && this.newNoteName && this.formPayload.invoice_notes) {
                try {
                    await this.$store.dispatch('orderNote/postData', {
                        payload: {
                        name: this.newNoteName,
                        note: this.formPayload.invoice_notes
                        }
                    });
                    this.fetchOrderNotes();
                    this.saveNoteChecked = false;
                    this.newNoteName = "";
                } catch(err) {
                    let msg = "Gagal menyimpan catatan. Pastikan maksimal 5 catatan atau nama tidak duplikat.";
                    if (err.response && err.response.data && err.response.data.data) {
                        const errData = err.response.data.data;
                        if (errData.name && errData.name[0]) {
                            msg = errData.name[0];
                        } else if (errData.message) {
                            msg = errData.message;
                        }
                    }
                    errorNotification(this, "Error", msg);
                    return false;
                }
            }
            return true;
        },
        handlePhoneNumber(value) {
            const inputValue = value || "";

            let cleanedValue = inputValue.trim();
            if (cleanedValue.startsWith("0")) {
                cleanedValue = cleanedValue.substring(1);
            }
            if (cleanedValue.startsWith('62')) {
                cleanedValue = cleanedValue.substring(2)
            }
            this.formPayload = {
                ...this.formPayload,
                receiver_phone_number: cleanedValue
            }
        },
        searchCountry: _.debounce(function (e) {
            const search = e.target.value;
            this.searchQueryData = search;
            this.getCountry(search);
        }, 300),
        
        getCountry(search) {
            const isDialCode = /^\d+$/.test(search);
            const params = isDialCode ? { search: search } : { search: search };
           

            this.$http
                .get("/country-phone-codes?per_page=500", { params })
                .then((response) => {
                    const uniqueCountryListData = response.data.data.data.filter((item, index, self) =>
                        index === self.findIndex(obj => obj.dial_code_preview === item.dial_code_preview)
                    );
                    this.countryListData = uniqueCountryListData;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        removeLeadingZero() {
            if (this.formPayload.receiver_phone_number) {
                let value = this.formPayload.receiver_phone_number.toString();
                if (value && value.startsWith('0') && value.length > 1) {
                    this.formPayload.receiver_phone_number = parseInt(value, 10);
                }
            }
        },
        getAmountDp() {
            const rupiah = document.getElementById('amount-dp')
            rupiah.value = this.formatRupiah(rupiah.value, '')
            this.amount_down_payment = rupiah.value
        },
        methodPaymentSelection() {
            this.isFullPayment = !this.isFullPayment
            localStorage.setItem('is_full_payment', this.isFullPayment)
            if (this.isFullPayment) {
                this.amount_down_payment = ''
            }
        },
        getContentText(val) {
            this.formPayloadDelivery = {
                ...this.formPayloadDelivery,
                receiver_address: val,
            }
        },
        repeateAgain() {
            this.additional_costs.push({
                additional_fee_amount: 0,
                additional_fee_note: '',
            })
        },
        removeItem(index) {
            this.additional_costs.splice(index, 1)
        },
        prosess() {
            this.$router.push({ name: 'payment.success' })
        },
        getRupiah(index) {
            let rupiah = document.getElementById(`nominal-biaya-${index}`)
            rupiah.value = this.formatRupiah(rupiah.value.toString(), '')
            this.additional_costs[index].additional_fee_amount = rupiah.value
        },
        formatRupiah(angka, prefix) {
            const number_string = angka.replace(/[^,\d]/g, '').toString()
            const split = number_string.split(',')
            const sisa = split[0].length % 3
            let rupiah = split[0].substr(0, sisa)
            const ribuan = split[0].substr(sisa).match(/\d{3}/gi)

            if (ribuan) {
                const separator = sisa ? '.' : ''
                rupiah += separator + ribuan.join('.')
            }

            rupiah = split[1] !== undefined ? `${rupiah},${split[1]}` : rupiah
            return prefix === undefined ? rupiah : (rupiah || '')
        },
        onSearch(search, loading) {
            if (search.length) {
                loading(true)
                this.searchSales(loading, search, this)
            } else {
                loading(true)
                setTimeout(() => {
                    this.options = []
                    this.getSales()
                    loading(false)
                }, 500)
            }
        },
        searchSales: _.debounce((loading, search, vm) => {
            vm.$store.dispatch('sales/getData', {
                uuid: '',
                params: {
                    search: search,
                },
            })
                .then(response => {
                    // eslint-disable-next-line no-param-reassign
                    vm.options = []
                    response.data.data.data.forEach(item => {
                        vm.options.push({
                            title: item.name,
                            label: item.uuid,
                        })
                    })
                    loading(false)
                })
        }, 300),
        getSalesDetail(id) {
            this.$store.dispatch('sales/getData', {
                uuid: `/${id}`,
                params: '',
            })
                .then(result => {
                    // this.uom = result.data.data.name
                    this.options.push({
                        label: result.data.data.uuid,
                        title: result.data.data.name,
                    })
                }).catch(err => {
                    // eslint-disable-next-line no-console
                    console.log(err)
                })
        },
        getSales() {
            this.$store.dispatch('sales/getData', {
                uuid: '',
                params: {
                    per_page: 15,
                },
            }).then(result => {
                for (let index = 0; index < result.data.data.data.length; index++) {
                    const element = result.data.data.data[index]
                    this.options.push({
                        title: element.name,
                        label: element.uuid,
                    })
                }
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.log(err)
            })
        },
        handlePhoneNumberInput(value) {
            if (!value) {
                this.formPayloadDelivery.receiver_phone_number = '62';
            }
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/tour.scss';

// ─── Note Chips ──────────────────────────────────────────────────────────────
.note-chips-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 4px;
    margin-bottom: 8px;

    &::-webkit-scrollbar {
        height: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background: #d0d0d0;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
}

.note-chips {
    display: flex;
    flex-wrap: nowrap;
    gap: 6px;
    width: max-content;
    min-width: 100%;
}

.note-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 5px 12px;
    border-radius: 20px;
    border: 1.5px solid #E4E5EC;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    background: #fff;
    white-space: nowrap;
    transition: border-color 0.18s ease, background 0.18s ease, color 0.18s ease;
    user-select: none;
    position: relative;

    &:hover {
        border-color: #45B6AB;
        background: rgba(82, 206, 194, 0.06);
    }

    &.active {
        border-color: #45B6AB;
        background: rgba(82, 206, 194, 0.12);
        color: #2b9e96;
    }

    &.editing {
        border-color: #f0a500;
        background: rgba(240, 165, 0, 0.08);
        color: #a06800;
    }

    &--new {
        border-style: dashed;
        color: #6c757d;
        &:hover { color: #45B6AB; }
        &.active {
            border-color: #45B6AB;
            background: rgba(82, 206, 194, 0.08);
            color: #45B6AB;
        }
    }

    .chip-label {
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .chip-actions {
        display: none;
        align-items: center;
        gap: 4px;
        margin-left: 2px;
        svg {
            cursor: pointer;
            color: #aaa;
            transition: color 0.15s;
            &:hover { color: #45B6AB; }
            &:last-child:hover { color: #e04444; }
        }
    }

    &:hover .chip-actions {
        display: inline-flex;
    }
}

// ─── Edit mode banner ────────────────────────────────────────────────────────
.note-edit-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fffbe6;
    border: 1px solid #f0d080;
    border-radius: 8px;
    padding: 6px 10px;
    font-size: 12px;
    color: #7a5700;
    margin-bottom: 6px;
    gap: 8px;
    flex-wrap: wrap;
}

// ─── Textarea states ─────────────────────────────────────────────────────────
.note-compose-active {
    border-color: #45B6AB !important;
    box-shadow: 0 0 0 3px rgba(69, 182, 171, 0.14) !important;
    transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.note-edit-active {
    border-color: #f0a500 !important;
    box-shadow: 0 0 0 3px rgba(240, 165, 0, 0.12) !important;
    transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

// ─── Inline save form ────────────────────────────────────────────────────────
.note-save-inline {
    background: #f8f9ff;
    border: 1px solid #d0d7f5;
    border-radius: 8px;
    padding: 10px 12px;

    &__label {
        font-size: 12px;
        font-weight: 600;
        color: #444;
        margin-bottom: 6px;
    }
}

// ─── Char counter ─────────────────────────────────────────────────────────────
.note-char-count {
    font-size: 11px;
    line-height: 1;
}

// ─── Slide-down transition ───────────────────────────────────────────────────
.slide-down-enter-active,
.slide-down-leave-active {
    transition: max-height 0.25s ease, opacity 0.25s ease;
    overflow: hidden;
}
.slide-down-enter,
.slide-down-leave-to {
    max-height: 0;
    opacity: 0;
}
.slide-down-enter-to,
.slide-down-leave {
    max-height: 300px;
    opacity: 1;
}

.v-tour {
    .v-step {
        background-color: #334155;

        .v-step__arrow {
            border-color: #334155;
        }
    }
}

/* 1. Force a bold, highly visible border when the checkbox is UNCHECKED */
.custom-control-success .custom-control-input:not(:checked) ~ .custom-control-label::before {
    border: 2px solid #2b324f !important; /* Thick dark slate/black border */
    background-color: #ffffff !important;
}

/* 2. Maintain structural alignment across inner elements */
.custom-control-success .custom-control-label {
    display: inline-flex !important;
    align-items: center !important;
    line-height: 1 !important;
}

/* 3. Dead-center anchor for the checkbox box graphics */
.custom-control-success .custom-control-label::before,
.custom-control-success .custom-control-label::after {
    top: 50% !important;
    transform: translateY(-50%) !important;
    margin-top: 0 !important;
}

.card--sender {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
    width: 100%;
    padding: 0.5rem 1rem;
    margin-bottom: 0.5rem;
    cursor: pointer;
    gap: 0.5rem;

    background: #FFFFFF;

    &.active {
        background: rgba(82, 206, 194, 0.1);
        border: 1px solid #45B6AB;

        h6 {
            color: #45B6AB;
        }
    }

    .circle {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        background: #FEF9F5;
        border-radius: 50%;
        box-shadow: inset 1.67273px 1.67273px 3.34545px rgba(230, 219, 211, 0.2);

        .shopping-cart {
            font-weight: bolder;
            color: #F1B277;
        }

        .truck {
            font-weight: bolder;
            color: #E04444;
        }
    }

    h6 {
        margin-top: 5px;
        font-weight: 800;
        font-size: 14px;
        line-height: 150%;
        color: #000000;
    }
}
</style>

<style lang="scss" scoped>
body {
    background: #FFFFFF;
}

.form-payment {
    height: 100vh;

    .custom__form--input mb-0 {
        label {
            margin-bottom: 1rem !important;
        }
    }

    .image-box {
        width: 46px;
        height: 46px;
    }

    @mixin title-card {
        margin-bottom: 0 !important;
        font-weight: 800;
        font-size: 14px;
        color: #2B324F;
    }

    .card {
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04);
        border-radius: 12px;

        &.active--payment {
            background: rgba(82, 206, 194, 0.1);
            box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04);
            border: 1px solid #45B6AB;

            h5 {
                color: #45B6AB !important;
                font-weight: 800;
                margin-bottom: 0px;
            }
        }

        &.card--full__payment {
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            padding: 21.5px 16px;

            h5 {
                @include title-card;
                align-self: center;
            }

            span {
                font-weight: 800;
                font-size: 16px;
                color: #2B324F;
            }
        }

        &.card--down__payment {
            display: flex;
            justify-content: space-between;
            padding: 21.5px 16px;

            h5 {
                @include title-card;
            }

            small {
                font-weight: 400;
                font-size: 12px;
            }
        }
    }
}
</style>
